@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.settings.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String = "composeResources/mifos_mobile.feature.settings.generated.resources/"

internal val Res.array.faq_ans: StringArrayResource by lazy {
      StringArrayResource("string-array:faq_ans", "faq_ans", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 10, 2218),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10, 1570),
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10, 1506),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 1610),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 1658),
        ResourceItem(setOf(LanguageQualifier("gu"), ), "${MD}values-gu/strings.commonMain.cvr", 10, 3226),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 3086),
        ResourceItem(setOf(LanguageQualifier("hu"), ), "${MD}values-hu/strings.commonMain.cvr", 10, 1642),
        ResourceItem(setOf(LanguageQualifier("in"), ), "${MD}values-in/strings.commonMain.cvr", 10, 1342),
        ResourceItem(setOf(LanguageQualifier("kn"), ), "${MD}values-kn/strings.commonMain.cvr", 10, 3786),
        ResourceItem(setOf(LanguageQualifier("mr"), ), "${MD}values-mr/strings.commonMain.cvr", 10, 3370),
        ResourceItem(setOf(LanguageQualifier("ms"), ), "${MD}values-ms/strings.commonMain.cvr", 10, 1322),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 1470),
        ResourceItem(setOf(LanguageQualifier("si"), ), "${MD}values-si/strings.commonMain.cvr", 10, 3134),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 10, 1418),
        ResourceItem(setOf(LanguageQualifier("te"), ), "${MD}values-te/strings.commonMain.cvr", 10, 3254),
        ResourceItem(setOf(LanguageQualifier("ur"), ), "${MD}values-ur/strings.commonMain.cvr", 10, 2226),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 1506),
      ))
    }

internal val Res.array.faq_qs: StringArrayResource by lazy {
      StringArrayResource("string-array:faq_qs", "faq_qs", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 2229, 641),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1581, 421),
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1517, 345),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1621, 421),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1669, 441),
        ResourceItem(setOf(LanguageQualifier("gu"), ), "${MD}values-gu/strings.commonMain.cvr", 3237, 869),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 3097, 849),
        ResourceItem(setOf(LanguageQualifier("hu"), ), "${MD}values-hu/strings.commonMain.cvr", 1653, 401),
        ResourceItem(setOf(LanguageQualifier("in"), ), "${MD}values-in/strings.commonMain.cvr", 1353, 413),
        ResourceItem(setOf(LanguageQualifier("kn"), ), "${MD}values-kn/strings.commonMain.cvr", 3797, 861),
        ResourceItem(setOf(LanguageQualifier("mr"), ), "${MD}values-mr/strings.commonMain.cvr", 3381, 793),
        ResourceItem(setOf(LanguageQualifier("ms"), ), "${MD}values-ms/strings.commonMain.cvr", 1333, 409),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1481, 405),
        ResourceItem(setOf(LanguageQualifier("si"), ), "${MD}values-si/strings.commonMain.cvr", 3145, 993),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1429, 393),
        ResourceItem(setOf(LanguageQualifier("te"), ), "${MD}values-te/strings.commonMain.cvr", 3265, 917),
        ResourceItem(setOf(LanguageQualifier("ur"), ), "${MD}values-ur/strings.commonMain.cvr", 2237, 661),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1517, 345),
      ))
    }

internal val Res.array.feature_settings_faq_answers: StringArrayResource by lazy {
      StringArrayResource("string-array:feature_settings_faq_answers", "feature_settings_faq_answers", setOf(
        ResourceItem(setOf(LanguageQualifier("ml"), ), "${MD}values-ml/strings.commonMain.cvr", 10, 2804),
      ))
    }

internal val Res.array.languages: StringArrayResource by lazy {
      StringArrayResource("string-array:languages", "languages", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2003, 368),
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1863, 368),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2043, 380),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2111, 368),
        ResourceItem(setOf(LanguageQualifier("gu"), ), "${MD}values-gu/strings.commonMain.cvr", 4107, 368),
        ResourceItem(setOf(LanguageQualifier("hu"), ), "${MD}values-hu/strings.commonMain.cvr", 2055, 368),
        ResourceItem(setOf(LanguageQualifier("in"), ), "${MD}values-in/strings.commonMain.cvr", 1767, 368),
        ResourceItem(setOf(LanguageQualifier("kn"), ), "${MD}values-kn/strings.commonMain.cvr", 4659, 368),
        ResourceItem(setOf(LanguageQualifier("mr"), ), "${MD}values-mr/strings.commonMain.cvr", 4175, 392),
        ResourceItem(setOf(LanguageQualifier("ms"), ), "${MD}values-ms/strings.commonMain.cvr", 1743, 368),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1887, 372),
        ResourceItem(setOf(LanguageQualifier("si"), ), "${MD}values-si/strings.commonMain.cvr", 4139, 396),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1823, 368),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1863, 368),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("faq_ans", Res.array.faq_ans)
  map.put("faq_qs", Res.array.faq_qs)
  map.put("feature_settings_faq_answers", Res.array.feature_settings_faq_answers)
  map.put("languages", Res.array.languages)
}
